import { checkSearchQuery } from '@/lib/api/search';
import { Search } from 'lucide-react';
import { usePathname } from 'next/navigation';
import React from 'react';

interface SearchFormProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  translations: any;
  formClassName?: string;
  inputClassName?: string;
  buttonClassName?: string;
  autoFocus?: boolean;
}

export function SearchForm({
  searchQuery,
  setSearchQuery,
  translations,
  formClassName,
  inputClassName,
  buttonClassName,
  autoFocus = false
}: SearchFormProps) {
  const path = usePathname();
  return (
    <form
      onSubmit={(e) => handleSearchSubmit(e, searchQuery, translations, path)}
      className={formClassName}
    >
      <input
        type="search"
        value={searchQuery}
        // disabled={true}
        // readOnly={true}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder={translations.searchPlaceHolder}
        className={inputClassName}
        aria-label="Search"
        autoFocus={autoFocus}
      />
      <button type="submit" className={buttonClassName} aria-label="Search">
        <Search size={18} />
      </button>
    </form>
  );
}

export const handleSearchSubmit = async (
  e: React.FormEvent,
  searchQuery: string,
  translations: any,
  path: string
) => {
  e.preventDefault();

  // Determine content type based on current path
  const contentType = path.startsWith('/gif') ? 'gif' : 'post';

  try {
    // Quick api request for sensitive search query
    const { response, error } = await checkSearchQuery(searchQuery, contentType);
    // If the search query is not sensitive, redirect to the search page
    if (response?.status === 200) {
      window.location.href = `${translations.path}${contentType}/search?search=${encodeURIComponent(
        searchQuery
      )}`;
    } else if (error.response?.status === 451) {
      // If the search query is sensitive, show alert
      window.alert(translations.sensitivePrompt);
      return;
    } else {
      // For other errors, still redirect to search page
      window.location.href = `${translations.path}${contentType}/search?search=${encodeURIComponent(
        searchQuery
      )}`;
    }
  } catch (error: any) {
    // For other errors, still redirect to search page
    window.location.href = `${translations.path}${contentType}/search?search=${encodeURIComponent(
      searchQuery
    )}`;
  }
};
